export default __webpack_public_path__ + "static/media/coffee.3401109f.jpg";